import '../../Shared/js/polyfills/';
import './vendor/';
import './common/common';

import { getWidget } from './common/widget';

(function () {
    'use strict';

    function main() {
        const widget = getWidget();
        if (!widget.length) return;
        var data = WhistleOut.readLookupData(widget);

        var controller = {
            init: function () {
                controller.bind();
            },

            bind: function () {
                var initialSlide = controller.getInitialSlide();
                widget
                    .find('#deals-carousel')
                    .slick({
                        speed: 500,
                        appendArrows: wo$('.deals-footer'),
                        initialSlide: initialSlide
                    })
                    .on('afterChange', function (event, slick, currentSlide) {
                        controller.dealShown(currentSlide);
                    });
                widget.show();

                widget.find('#whistleout').click(function () {
                    WhistleOut.trackEvent('DealCarousel', 'Click', 'WhistleOut');
                });

                widget.find('#deals-carousel a').click(function () {
                    var url = wo$(this).data('url');
                    var win = window.open(url, '_top');
                    win.focus();

                    var label = wo$(this).data('label');
                    WhistleOut.trackEvent('DealCarousel', 'DealClick', label);
                });

                widget.find('#wo').click(function () {
                    controller.edit();
                });

                controller.dealShown(initialSlide);
            },

            dealShown: function (index) {
                if (index >= 0 && index <= data.items.length) {
                    if (!data.items[index].shown) {
                        widget.find('#tracking').html(data.items[index].trackingHtml);
                        data.items[index].shown = true;
                    }
                    widget.find('#wo').data('id', data.items[index].id);
                }
            },

            edit: function () {
                var wo = widget.find('#wo');
                var url = wo.data('base') + wo.data('id');
                var win = window.open(url, '_top');
                win.focus();
            },

            getInitialSlide: function () {
                var max = 0;
                var rotations = [];
                wo$.each(data.items, function (index, value) {
                    max += value.rotations;
                    rotations.push(max);
                });

                var randomIndex = Math.floor(Math.random() * max);
                var selectedIndex = 0;
                wo$.each(rotations, function (index, value) {
                    if (randomIndex <= value) {
                        selectedIndex = index;
                        return false;
                    }
                });

                return selectedIndex;
            }
        };
        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
